.formGrid {
  align-items: stretch;
  display: grid;
  gap: 0 var(--space-medium);
  grid-template-columns: repeat(var(--grid-columns, 1), minmax(0, 1fr));
  grid-template-rows: repeat(1, 1fr);

  --grid-columns: 2;
}

@media screen and (width <= 800px) {
  .formGrid {
    --grid-columns: 1;
  }
}
